"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var api_1 = require("../../api");
var _1 = require(".");
var InventoryItemGroupSearchField = /** @class */ (function (_super) {
    __extends(InventoryItemGroupSearchField, _super);
    function InventoryItemGroupSearchField(api, label, isRequired, requiredValidationMessage, allowMultipleSelect, key, textKey) {
        if (isRequired === void 0) { isRequired = false; }
        if (allowMultipleSelect === void 0) { allowMultipleSelect = false; }
        var _this = _super.call(this, api, label, api_1.EndpointUrls.Inventory + '/Groups/SearchForDropdown', 'id', 'name', 'name', isRequired, requiredValidationMessage, allowMultipleSelect, key, textKey) || this;
        _this.setPlaceholderLabel(label);
        return _this;
    }
    return InventoryItemGroupSearchField;
}(_1.BaseSearchField));
exports.default = InventoryItemGroupSearchField;
